import { useTheme as useMeridianTheme } from '@amzn/meridian/theme';
import chevronLeftIconTokens from '@amzn/meridian-tokens/base/icon/chevron-left-small';
import chevronRightIconTokens from '@amzn/meridian-tokens/base/icon/chevron-right-small';
import { css } from '@emotion/css';
import IconButton from './IconButton';

interface ServicePaginationProps {
  page: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  isLoading: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
}

export default function ServicePagination({
  page,
  hasNextPage,
  hasPreviousPage,
  isLoading,
  onNextPage,
  onPreviousPage,
}: ServicePaginationProps) {
  const meridianTheme = useMeridianTheme();
  const containerClass = css({
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  });
  const controlsClass = css({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: 2,
    borderRadius: 10,
    border: `1px solid ${meridianTheme('themeBorderSubdued')}`,
    backgroundColor: meridianTheme('themeSurfaceDefault'),
  });
  const pageLabelClass = css({
    padding: '0 8px',
    color: meridianTheme('themeInkSubdued'),
    fontSize: 13,
    fontWeight: 500,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
  });

  return (
    <nav className={containerClass} aria-label="Pagination">
      <div className={controlsClass}>
        <IconButton
          iconTokens={chevronLeftIconTokens}
          label="Previous page"
          onClick={onPreviousPage}
          disabled={!hasPreviousPage || isLoading}
        />
        <span className={pageLabelClass}>Page {page} of many</span>
        <IconButton
          iconTokens={chevronRightIconTokens}
          label="Next page"
          onClick={onNextPage}
          disabled={!hasNextPage || isLoading}
        />
      </div>
    </nav>
  );
}
